export default __webpack_public_path__ + "40a93faa56585c51981558abf1ff7a07.png";